const VERSION = '3.9.1';
export default VERSION;
